import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { PagesComponent } from './pages.component';
import { LayoutModule } from '../layout/layout.module';
import { PagesRoutingModule } from './pages-routing.module';
import { HomeModule } from './home/home.module';
import { AuthorizationGuard } from '../guards/authorization.guard';
import { DealerModule } from './dealer/dealer.module';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [
    PagesComponent
  ],
  imports: [
    CommonModule,
    LayoutModule,
    RouterModule,
    PagesRoutingModule,
    HomeModule,
    DealerModule,
  ],
  exports: [
    PagesComponent
  ],
  providers: [
    AuthorizationGuard,
    DatePipe
  ]
})
export class PagesModule { }
